import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import firebase from "firebase/app";
import App from "./App";

const firebaseConfig = {
  apiKey: "AIzaSyBY2lrzSKIPb_kWFO7dY2jz4kmrP_5K82A",
  authDomain: "krishi-market-ut.firebaseapp.com",
  projectId: "krishi-market-ut",
  storageBucket: "krishi-market-ut.appspot.com",
  messagingSenderId: "577324826047",
  appId: "1:577324826047:web:41fc3fcd6affd1bc91f50a",
  measurementId: "G-EYJ49F5NJN",
};
firebase.initializeApp(firebaseConfig);
firebase.analytics();

let root = document.getElementById("root");
ReactDOM.render(<App />, root);
